export default "Chauffe-eau thermodynamique 2026 — Aides MPR + CEE cumulables | Solution Éco France";
